
(() => {
  const selector = 'options-selection select';
  let requestNumber = 0;

  async function updateVariant() {
    const selects = [...document.querySelectorAll(selector)];
    if (selects.length !== 3) return;

    const form = document.querySelector('form[action*="/cart/add"]');
    const variantInput = form?.querySelector('[name="id"]');
    const variantSelect = document.querySelector(
      'variant-selection select[data-variants]'
    );

    if (!form || !variantInput) return;

    const currentRequest = ++requestNumber;

    // Match the option names configured in Shopify.
    const names = [
      'Forward Position',
      'Middle Position',
      'Rear Position'
    ];

    const selectedOptions = selects.map((select, index) => ({
      name: names[index],
      value: select.value
    }));

    const handle = location.pathname.split('/products/')[1]?.split('/')[0];
    if (!handle) return;

    const query = `
      query FindVariant(
        $handle: String!,
        $options: [SelectedOptionInput!]!
      ) {
        product(handle: $handle) {
          variantBySelectedOptions(selectedOptions: $options) {
            id
            availableForSale
          }
        }
      }
    `;

    try {
      const response = await fetch('/api/2025-10/graphql.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          query,
          variables: {
            handle,
            options: selectedOptions
          }
        })
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const result = await response.json();

      if (currentRequest !== requestNumber) return;
      if (result.errors?.length) {
        throw new Error(result.errors.map(e => e.message).join('; '));
      }

      const variant = result.data?.product?.variantBySelectedOptions;
      const id = variant?.id?.split('/').pop();
      console.log('[Variant fix] Shopify response:', {
  variant,
  id,
  available: variant?.availableForSale
});

      if (!id || !variant.availableForSale) {
        variantInput.value = '';
        if (variantSelect) variantSelect.value = '';
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        console.log('[Variant fix] Unavailable combination');
        return;
      }

// Add the missing variant to Empire's limited dropdown.
function ensureVariantOption(select, id) {
  if (!select) return;

  let option = [...select.options].find(
    option => option.value === id
  );

  if (!option) {
    option = new Option(id, id, false, false);
    select.add(option);
  }

  select.value = id;
}

// Update both selectors with the correct Shopify variant.
ensureVariantOption(variantInput, id);

if (variantSelect && variantSelect !== variantInput) {
  ensureVariantOption(variantSelect, id);
}

variantInput.dispatchEvent(new Event('change', { bubbles: true }));

console.log('[Variant fix] Form synchronized:', id);

      console.log('[Variant fix] Resolved:', id);
    } catch (error) {
      if (currentRequest === requestNumber) {
        console.error('[Variant fix]', error);
      }
    }
  }

  document.addEventListener('change', event => {
    if (event.target.matches(selector)) {
      setTimeout(updateVariant, 150);
    }
  });

  console.log('[Variant fix] Loaded');
})();
